module.exports = __webpack_public_path__ + "static/media/logo-transp.eb986cb6.png";